window.rightColumnStickyOnScroll = function(){

    if( SITE_INFO['name'] != "markets" ){
        //if standard article OR polls page - all verticals - float rightrail ad-box-top ad on scroll
        if(
            ( $('body.article').length > 0 && $('div.beta div').first().hasClass('RC-AD-BOX-TOP') )
            || ( $('body.polls').length > 0 )
            || ( $('body.maps').length > 0 )
            || ( $('body.live_results').length > 0 )
            || ( $('body.video').length > 0 )
        ){

            /**
             * A.A. code to make the right column sticky and then scrollable
             */

            var scroll_distance = 400;
            if($('body.polls').length || $('body.maps').length) {
                scroll_distance = 300;
            }

            var sticky_base_class = 'sticky-right-col';
            $('.beta').wrapInner("<div class='"+sticky_base_class+"'></div>");

            var sticky_el = '.'+sticky_base_class;
            var beta_top_st = $('.beta').offset().top;
            var distroscale_div = "#ds_cpp";

            $(window).on('scroll', function(event){

                var w_top = $(this).scrollTop();

                if( w_top < beta_top_st ){

                    $(sticky_el).removeClass('scroll');
                    $(sticky_el).css('margin-top', '0px');

                }else if( w_top > beta_top_st && w_top < (beta_top_st + scroll_distance) ){

                    $(sticky_el).addClass('scroll');
                    $(sticky_el).removeClass('stop');
                    if( $(sticky_el).parent().find(distroscale_div).length > 0 ){
                        $(sticky_el).css('margin-top', '592px');
                    }else{
                        $(sticky_el).css('margin-top', '0px');
                    }

                }else if( w_top > (beta_top_st + scroll_distance) ){

                    $(sticky_el).addClass('stop');
                    if( $(sticky_el).parent().find(distroscale_div).length > 0 ){
                        $(sticky_el).css('margin-top', '0px');
                    }else{
                        $(sticky_el).css('margin-top', scroll_distance+'px');
                    }
                }
            });

        }
    }
}

window.backToTopIcon = function(){
    //BACK TO TOP
    if($('body').hasClass('article')){

        //this will only get executed only and only if the body has a class of article it
        $('body').append('<div class="back-to-top"><img title="Scroll To Top" src="/asset/img/backToTop.png" /></div>');

        var backToTop = function(){
            var scrollTrigger = 300;

            var scrollTop = $(window).scrollTop();

            if(scrollTop > scrollTrigger){
                $('.back-to-top').addClass('show');
            } else{
                $('.back-to-top').removeClass('show');

            }
        }

        backToTop();
        $(window).on('scroll',function(){
            backToTop();
        })

        $('.back-to-top').on('click', function(e){
            e.preventDefault();
            $('html, body'). animate({
                scrollTop:0
            }, 700);
        });
    }
}

function leaderboardSettings(options){

    var checkIfArticle = function(){

        // Turn off on video per Ivan 05/14/2020
        return false;

        if( $('body.article').length > 0 && $('div.beta div').first().hasClass('RC-AD-BOX-TOP') ){
            return true;
        }

        return false;
    }

    var checkIfPolls = function(){

        // Setting this as false permanently to turn off on polls per Ivan - A.A. 03-12-2019
        // Turning it back on 04/12/2019 per Ivan
        // Turning it back off 10/23/2019 per Ivan
        return false;

        if( $('body.polls').length > 0 || $('body.maps').length > 0 || $('body.live_results').length>0 ){
            return true;
        }

        return false;

    }

    var checkIfVideo = function(){

        // Turn off on video per Ivan 05/07/2020
        return false; 
        return $('body.video').length > 0;
    }

    options = options || {};

    var settings = {
        fixed_class: 'fixed-leaderboard',
        leaderboard_cookie: 'rc-ad_rc-ad-top-banner_fixed-leaderboard_close-ad',
        hide_class: 'hide',
        top_pos_class: 'top',
        tynt_check: '.tynt-ad-fence',
        top_banner_ad_el: $('.RC-AD-TOP-BANNER'),
        container_top: $('#container').length ? $('#container').offset().top : 0,
        container_width: $('#container').length ? $('#container').width() : 0,
        alpha_left: $('.alpha').length ? $('.alpha').offset().left : 0,
        alpha_width: $('.alpha').length ? $('.alpha').width() : 0,

        article: checkIfArticle(),
        polls: checkIfPolls(),
        video: checkIfVideo(),
        on_article: {
            reset: 1000,
        },
        on_polls: {
            reset: 300,
        },
        on_video: {
            reset: 1000,
        },
        hooks: [
            'rightColumnStickyOnScroll',
            'backToTopIcon'
        ],
        scroll_hooks: [],
    };

    $.extend(true, settings, options);

    return settings;
};

function leaderboardActions(set){

    if( SITE_INFO['name'] == "science" || SITE_INFO['name'] == 'policy' ){ return; }

    var pos_settings = {};
    if(set.article == true){

        pos_settings = set.on_article;

    }else if(set.polls == true){

        pos_settings = set.on_polls;

        //if not valid page exit early
    }else if(set.video == true){

        pos_settings = set.on_video;

        //if not valid page exit early
    }else {
        return;
    }

    //if not at least 1180 pixels wide exit early
    var winWidth = $(window).width();
    if( winWidth <= 1180 ){
        return;
    }

    var timeout = null;
    var reset = pos_settings.reset+set.container_top;
    var container_top = set.container_top;
    var cookie = set.leaderboard_cookie;

    $(window).scroll(function (event) {

        clearTimeout(timeout);

        timeout = setTimeout(function() {
            if(!readCookie(cookie)){

                var topPos  = $(this).scrollTop();
                var position = ( ( $(window).width() - $('#container').width() ) / 2) + $('.beta').width() + 90;

                //if top pass the container top reset the ad to the top of the page
                if(topPos <= container_top){

                    //remove all classes to reset ad to the top of the page to orinal position
                    $(set.top_banner_ad_el).removeClass(set.fixed_class)
                        .removeClass(set.top_pos_class)
                        .removeClass(set.hide_class)
                        .css({'right': 'initial'});

                    //if passed the container top position and below reset then fix the ad
                }else if(topPos > container_top && topPos < reset){

                    $(set.top_banner_ad_el).removeClass(set.hide_class);

                    //fix add to top if not already done so
                    if( !$(set.top_banner_ad_el).hasClass(set.fixed_class) ){

                        $(set.top_banner_ad_el).addClass(set.fixed_class);
                        //.css({'right' : position+'px'});

                        //if tynt ad on page then fix to top
                        if( $(set.tynt_check).length > 0 && !$(set.top_banner_ad_el).hasClass(set.top_pos_class) ){
                            $(set.top_banner_ad_el).addClass(set.top_pos_class);
                        }
                    }

                    //Using current jquery structure to adjust ad position based to screen size
                    if(winWidth > 1179 && winWidth < 1281 && $("body.article").length > 0)
                    {
                        $(set.top_banner_ad_el).css({'right' : 439+'px', 'margin-right' : '7px'});

                    }else if(winWidth > 1279 && $("body.article").length > 0)
                    {
                        $(set.top_banner_ad_el).css({'right' : 'auto', 'margin-right' : '41px'});
                    }else if(winWidth > 1279 && winWidth < 1300 && $("body.article").length > 0)
                    {
                        $(set.top_banner_ad_el).css({'right' : 451+'px'});

                    }else{
                        $(set.top_banner_ad_el).css({'right' : position+'px'});
                    }
                    //$(set.top_banner_ad_el).css({'right' : position+'px'});

                    //if passed the reset position then hide it
                } else if(topPos >= reset){

                    $(set.top_banner_ad_el).addClass(set.hide_class);

                }

            }

            if(set.scroll_hooks.length > 0){
                //call other functions dynamically that are hook into the on scroll event
                for (var i = 0; i < set.scroll_hooks.length; i++) {
                    window[set.scroll_hooks[i]]();
                }
            }

        }, 10);

    }).scroll();

    if(set.hooks.length > 0){
        //call other functions dynamically that are hook into the on scroll event
        for (var i = 0; i < set.hooks.length; i++) {
            window[set.hooks[i]]();
        }
    }
}

function init_leaderboard(opts)
{
    opts = opts || {};
    leaderboardActions(leaderboardSettings(opts));
}

export default init_leaderboard;